import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IPackageType {
  id: string | number;
  name: string;
}

export class IPackageTypeResponse {
  @Type(() => IPackageType)
  result: IPackageType;
}

export class IPackageTypeslListResponse extends IPagination {
  @Type(() => IPackageType)
  results: IPackageType[];
}

export class IPackageTypesQueryDto extends IQueryPaginationDto {
  name?: string;
}
